<template>
  <div>
    <v-breadcrumbs
      :items="breadcrumbs"
      class="grey lighten-2 white--text"
    ></v-breadcrumbs>
    <v-progress-circular
      v-if="loading"
      :size="100"
      :width="4"
      color="fmq_black"
      indeterminate
      class="d-flex mx-auto py-8 mt-8"
    ></v-progress-circular>
    <div v-else>
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-4">
          <v-btn
            small
            depressed
            color="fmq_gray"
            dark
            outlined
            to="/cadastro-linha"
          >
            <v-icon small> mdi-arrow-left </v-icon>Voltar</v-btn
          >
        </div>
        <LinhasFormulario @send="editar" :linha="linha" />
      </div>
    </div>
    <AlertSuccess
      :dialog="success"
      dialogMessage="Linha editada com sucesso"
      @close="goToLinhas"
    />
    <AlertError :alertError="error" :messageError="messageError" />
  </div>
</template>

<script>
import { editarLinha, exibirLinha } from "@/services/linhas";
import LinhasFormulario from "@/components/linhas/LinhasFormulario.vue";
export default {
  name: "LinhasDeProdutosEditar",
  components: { LinhasFormulario },
  data: () => ({
    breadcrumbs: [
      {
        text: "Linha de Produtos",
        disabled: false,
        to: "/cadastro-linha",
      },
      {
        text: "Editar Linha de Produtos",
        disabled: true,
        to: "",
      },
    ],
    error: false,
    success: false,
    loadingBtn: false,
    messageError: null,
    linha: {},
    loading: false
  }),
    beforeCreate() {
    if(this.$store.state.user.data.tipo === "Representante") {
      this.$router.push({path: '/'})
    }
  },
  created() {
    this.exibir();
  },
  methods: {
    async editar(event) {
      this.error = false;
      this.sucess = false;
      this.loadingBtn = true;
      try {
        await editarLinha(this.$route.params.id, event).then(() => {
          this.success = true;
        });
        this.loadingBtn = false;
      } catch (e) {
        this.loadingBtn = false;
        this.error = true;
        this.messageError = e.response.data.message;
      }
    },
    async exibir() {
      this.error = false;
      this.loading = true;
      try {
        const resp = await exibirLinha(this.$route.params.id);
        this.linha = resp.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.error = true;
        this.messageError =  e.response.data.message;
      }
    },
    goToLinhas() {
      this.sucess = false;
      this.$router.push({ name: "LinhasDeProdutos" });
    },
  },
};
</script>

<style></style>
